
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ShoppingCart } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const ClientConversionSection = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="bg-gradient-to-b from-white to-blue-50 rounded-2xl p-8 mb-12 shadow-xl border border-blue-100">
      <div className="max-w-4xl mx-auto">
        {/* Header with premium styling */}
        <h2 className="text-3xl font-bold text-blue-900 mb-8 text-center">
          How We Closed $25,000 Clients With Cold Email
        </h2>
        
        {/* Case study proof with animation and shadow */}
        <div className="mb-12">
          <motion.div
            className="rounded-xl overflow-hidden shadow-2xl border-2 border-blue-200"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <motion.img
              src="/lovable-uploads/35c6b59f-3cef-409a-bbf7-530728fee662.png"
              alt="$25,000 payment proof from Bank of America showing client payment"
              className="w-full"
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>
        </div>
        
        {/* Call to action section with premium design */}
        <div className="mt-12 pt-8 border-t-2 border-blue-100">
          {/* CTA Text with highlighted background */}
          <motion.div
            className="mb-12 p-6 bg-blue-600 bg-opacity-10 rounded-xl"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h3 className="text-2xl font-bold text-center text-blue-800">
              And much much more strategies for mastering the art and science of cold email for scale
            </h3>
          </motion.div>
          
          {/* Button section with animation */}
          <motion.div 
            className="flex justify-center mb-8"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <a href="https://whop.com/checkout/plan_lgxEwNdJ45OQ3?d2c=true" target="_blank" rel="noopener noreferrer">
              <Button 
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-6 px-10 text-xl flex items-center gap-3 rounded-xl shadow-lg shadow-blue-300/50 transform transition-all duration-300 hover:scale-105 hover:shadow-blue-400/50"
              >
                <ShoppingCart className="h-6 w-6" />
                BUY NOW
              </Button>
            </a>
          </motion.div>
          
          {/* Limited offer text */}
          <motion.p 
            className="text-center text-blue-600 font-medium mb-12"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            Only available right now on this page
          </motion.p>
          
          {/* Trust badges with improved layout */}
          <div className="flex flex-col items-center justify-center space-y-8">
            {/* Money back guarantee badge */}
            <motion.div
              className="hover:scale-105 transition-transform duration-300 flex flex-col items-center"
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.7 }}
            >
              <img
                src="/lovable-uploads/59223f32-1de0-4fc6-9e84-5ef83b5dbd37.png"
                alt="30 Day Money Back Guarantee Badge"
                className={`${isMobile ? 'h-40 w-auto' : 'h-48 w-auto'} filter drop-shadow-md`}
              />
              <p className="text-center text-gray-700 mt-3 max-w-md mx-auto text-sm px-2">
                For any questions or support, please email igor@munger.ai.
              </p>
            </motion.div>
            
            {/* Payment security badge */}
            <motion.div
              className="bg-white p-2 rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300"
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.9 }}
            >
              <img
                src="/lovable-uploads/c409c611-b1b0-4741-9dc5-34e85caa691a.png"
                alt="Safe and Secure SSL Encrypted - PayPal, Mastercard, Visa, Discover, American Express"
                className={`w-auto ${isMobile ? 'h-10' : 'h-12'}`}
              />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientConversionSection;
